import { AUTH_ORIGINS } from "../../account-links";

export const VERIFIED_PUBLIC_ROUTES = Object.freeze({
  registration: Object.freeze({
    evidence: "auth-web:GET /register",
    origin: "https://auth.blenderbridge.com",
    origins: AUTH_ORIGINS,
    pathname: "/register",
  }),
  /*
   * Оформление заказа живёт на том же кабинете, что и регистрация: счёт
   * принадлежит аккаунту, а аккаунт есть только там. Отдельного происхождения
   * у него нет и быть не должно — иначе появилось бы второе место, куда
   * страница тарифов может увести человека.
   */
  checkout: Object.freeze({
    origins: AUTH_ORIGINS,
    pathname: "/checkout",
  }),
});
